import { useEffect, useState } from 'react';
import env from '../environment';
import Api from '../api/global.service';
import riesgoEudrCalculator from '../nuup/utils/riesgoEudrCalculator';
import getRiesgoEudrLabel from '../nuup/utils/getRiesgoEudrLabel';
import { getUsaEUDR } from '../components/content/coop-config';

const useEudrProdRisk = ({ productor_id }) => {
  const [riesgoEudr, setRiesgoEudr] = useState(null);
  useEffect(() => {
    if (getUsaEUDR() && productor_id) {
      getDataEUDR();
    }
  }, [productor_id]);

  const getDataEUDR = () => {
    Api.search('parcelas_all', {
      sort: [{ column: 'cuenta', sort: 'asc' }],
      filter: [
        { column: 'id_ciclo', operator: '=', value: localStorage.getItem(`${env.appName}-ciclo_id`) },
        { column: 'cuenta_id', operator: '=', value: productor_id },
      ],
    }).then(response => {
      const parcelas = response.data;
      const risk = parcelas.reduce((risk, p) => {
        const currentRisk = riesgoEudrCalculator(
          p.poligono,
          p.id_riesgo_eudr_user,
          p.alertas_error_poligono_count,
          p.id_riesgo_eudr_whisp,
          p.areas_naturales_count
        );
        if (currentRisk && currentRisk < risk) {
          return currentRisk;
        }
        return risk;
      }, 5);
      const riskLabel = getRiesgoEudrLabel(risk);
      setRiesgoEudr(riskLabel);
    });
  };

  return { riesgoEudr };
};

export default useEudrProdRisk;
